module.exports = "<div class=\"animate-wrapper line-border\"><ui-view class=\"animate\"></ui-view></div>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./~/pug-html-loader/lib!./src/app/site/site.jade
// module id = 408
// module chunks = 0